import { render } from "./KanbanFiltros.vue?vue&type=template&id=5ec908b8&scoped=true"
import script from "./KanbanFiltros.vue?vue&type=script&lang=js"
export * from "./KanbanFiltros.vue?vue&type=script&lang=js"

import "./KanbanFiltros.vue?vue&type=style&index=0&id=5ec908b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ec908b8"]])

export default __exports__